import { Injectable, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TntToolStateService } from './tnt-tool-state.service';
import { TntToolVersionService } from '../tnt.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class TntToolVersionComponent implements OnDestroy {

    private ngUnsubscribe: Subject<void> = new Subject<void>();

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    constructor(
        private formBuilder: FormBuilder,
        private toolEditDataItem: TntToolStateService,
        private service: TntToolVersionService,
    ) {
        this.toolEditDataItem.state$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((state) => {
            });
        this.toolEditDataItem.get();

    }

    handleRead = (force: boolean, dataItem: any) => {
        return this.service
            .read('/' + dataItem.Id + '/ToolVersions', true);
    }


    editForm = this.formBuilder.group({})

    columns = [
        {
            field: 'ToolNumber',
            title: 'Tool Number',
            width: "135",
        },
        // {
        //     field: 'OwnerGmin',
        //     title: 'Tool Owner',
        //     filter: 'numeric',
        //     format: '{0:i}',
        //     width: "135",
        // },
        {
            field: 'ToolDescription',
            title: 'Description',
        },
        {
            field: 'ToolComment',
            title: 'Comment',
        },
        {
            field: 'TeamCenterLink',
            title: 'Team Center Link',
            template: {
                type: 'link'
            }
        },
        {
            field: 'CreatedDate',
            title: 'Created Date',
            width: 85,
            template: {
                type: 'date',
                dateFormat: 'shortDate'
            }
        },
    ]



    toolVersionTemplate = {
        title: "Tool Versions",
        titleDetail: "ToolNumber",
        isDetail: true,
        controls: {
            add: true,
            edit: true,
            delete: false,
        },
        editForm: this.editForm,
        read: this.handleRead,
        // save: this.handleSave,
        columns: this.columns,
        service: this.service,
    }

}
